import {
    getIsApiPendingCountries,
    getPlanValue,
    getQuoteForm,
    getSegmentValue,
} from '../../../selectors/travelKe/quote';
import { apiTransitionCountries, fetchAllCountriesSuccess } from '../../../actions/travelKe/quote';
import { getAccessToken } from '../../../selectors/travelKe/payments';
import axios from 'axios';

export const getCountriesService = (store, next, action) => {
    (async () => {
        // if (!getIsApiPendingCountries(store.getState())) {
        store.dispatch(apiTransitionCountries.pending());
        try {
            const resp = await getCountries(store.getState());

            store.dispatch(fetchAllCountriesSuccess(resp.data));
            store.dispatch(apiTransitionCountries.success());
        } catch (e) {
            console.error(e);
            store.dispatch(apiTransitionCountries.failure());
        }
        // }
    })();
    return next(action);
};

const getCountries = async (state) => {
    const loginData = getAccessToken(state);
    const quotation = getQuoteForm(state);
    const plan = getPlanValue(state);
    const segment = getSegmentValue(state);

    const cover = quotation.selectedCover.value;

    try {
        const url = '/om-api/travel-ke/countries';
        const restrictedCountriesUrl = `/om-api/travel-ke/country-map?cover=${cover}&plan=${plan}&segment=${segment}`;
        return await axios.get(cover === 'pilgrimage' ? restrictedCountriesUrl : url, {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
